import React from 'react';
import {
  Box,
  chakra,
  UnorderedList,
  useColorModeValue
} from '@chakra-ui/react';
import { normalizeString } from 'utils';
import theme from 'prism-react-renderer/themes/github';
import { Code } from './code';

const { toKebabCase } = normalizeString;

function Tab({ title, body, isActive }: any) {
  return (
    <Box
      display={isActive ? 'block' : 'none'}
      pos="relative"
      id={toKebabCase(title)}
      role="tabpanel"
      aria-labelledby={`tab-${toKebabCase(title)}`}
    >
      <Code
        withTabs
        theme={theme}
        language={body.language}
        highlightedLines={body.highlightedLines}
        withLineNumbers
        withCopy
      >
        {body.code}
      </Code>
    </Box>
  );
}

export function Tabs({ tabs }: any) {
  const [activeTab, setActiveTab] = React.useState(tabs[0].title);

  const activeBg = '#282C34';
  const inactiveBg = useColorModeValue('gray.100', '#18191C');
  const hoverBg = useColorModeValue('gray.50', '#111214');

  const activeColor = 'white';
  const inactiveColor = useColorModeValue('gray.800', 'gray.300');

  const borderColor = useColorModeValue(
    'rgba(0,0,0,0.1)',
    'rgba(255,255,255,0.05)'
  );

  return (
    <Box py={4} mx="auto">
      <UnorderedList
        role="tablist"
        display="flex"
        flexWrap="wrap"
        listStyleType="none"
        m={0}
      >
        {tabs.map(({ _key, title }: any, index: number) => {
          const isActive = title === activeTab;
          const isFirst = index === 0;
          const isLast = index === tabs.length - 1;

          return (
            <li key={_key} role="presentation">
              <chakra.button
                id={`tab-${toKebabCase(title)}`}
                type="button"
                role="tab"
                py={2}
                px={4}
                bg={isActive ? activeBg : inactiveBg}
                borderTopLeftRadius={isFirst ? 'md' : '0'}
                borderTopRightRadius={isLast ? 'md' : '0'}
                color={isActive ? activeColor : inactiveColor}
                borderLeft={isFirst ? '1px solid' : 'none'}
                borderRight="1px solid"
                borderTop="1px solid"
                borderColor={borderColor}
                pointerEvents={isActive ? 'none' : 'auto'}
                textStyle="sm-medium"
                aria-controls={toKebabCase(title)}
                aria-selected={activeTab === title ? 'true' : 'false'}
                onClick={setActiveTab.bind(null, title)}
                transition="background 0.2s"
                _hover={{
                  bg: !isActive && hoverBg
                }}
              >
                {title}
              </chakra.button>
            </li>
          );
        })}
      </UnorderedList>
      <div>
        {tabs.map(({ _key, title, body }: any) => {
          const isActive = title === activeTab;

          return (
            <Tab key={_key} title={title} body={body} isActive={isActive} />
          );
        })}
      </div>
    </Box>
  );
}
